import Logo from '../../components/svgs/logo';
import CraneImage from '../../assets/images/crane.jpg';
import BtBackground from '../bt-background/bt-background';
import { DOMAttributes, useEffect, useState }  from 'react';
import appState from '../../state/AppStateContainer';
import { ServiceAuth } from '../../services/service-auth';
import { AxiosError } from 'axios';
import BtColumn from '../bt-column/bt-column';
import BtGrid from '../bt-grid/bt-grid';
import BtRow from '../bt-row/bt-row';
import BtCenter from '../bt-center/bt-center';
import { useTranslation, Trans } from "react-i18next";

type CustomElement<T> = Partial<T & DOMAttributes<T> & { children: any }>;

declare global {
  namespace JSX {
    interface IntrinsicElements {
      ['bt-center']: CustomElement<any>;
    }
  }
}

export default function PageHvdLogin() {
  const [t] = useTranslation('login', { keyPrefix: 'sso' } );
  const [error, setError] = useState('');
  const logoutLink = '';

  useEffect(() => {
    (async () => {
      const token = new URL(window.location.href).searchParams.get('token');
      const product = new URL(window.location.href).searchParams.get('product');
      const country = new URL(window.location.href).searchParams.get('country');
      const urlToRedirectParam = new URL(window.location.href).searchParams.get('urlToRedirect');

      if (token) {
        try {
          const data = await ServiceAuth.finishHvdSignIn(token, product, country);
          if (data && !data.error) {
            await appState.setToken(data.accessToken, true);
            appState.setTheme(data.theme || null);
            const urlToRedirect = urlToRedirectParam ? `${window.location.origin}${decodeURIComponent(urlToRedirectParam)}` : appState.loadString('urlToRedirect');
            localStorage.removeItem('urlToRedirect');
            window.location.href = urlToRedirect ?? '/';
            return;
          } else {
            setError(data?.error || 'Unknown error');
          }
        } catch (e) {
          const err = e as AxiosError;
          const data: any = err.response?.data;
          console.log(data)
          setError(data?.error || 'Unknown error');
        }
        appState.setState({loader: false});
      } else {
        const url = new URL(window.location.href);
        const btoa = window.btoa;
        const params = [];
        if (product) {
          params.push(`product=${product}`);
        }
        if (country) {
          params.push(`country=${country}`);
        }
        if (urlToRedirectParam) {
          params.push(`urlToRedirect=${urlToRedirectParam}`);
        }
        const queryString = '?' + params.join('&');
        const returnUrl = btoa(url.origin + `/hvdlogin${queryString.length > 1 ? queryString : ''}`);

        window.location.href = `https://accurator${appState.isTest() ? '.staging' : ''}.hvdhub.com/Login?title=${btoa('Accurator')}&returnUrl=${returnUrl}&country=${btoa('SE')}&language=sv`;
      }
    })();
  }, []);

  function renderSsoError(error: string) {
    if (error.startsWith('No organization')) {
      return <Trans t={t} i18nKey="errorMessage.noOrganization" values={{logoutLink}} components={{a: <a/>}} />;
    } else if (error.startsWith('No application role')) {
      return <Trans t={t} i18nKey="errorMessage.noApplicationRole" values={{logoutLink}} components={{a: <a/>}} />;
    } else if (error.startsWith('No code')) {
      return <Trans t={t} i18nKey="errorMessage.noCode" components={{a: <a/>}} />;
    } else if (error.startsWith('invalid_grant: 54005')) {
      return <Trans t={t} i18nKey="errorMessage.usedCode" components={{a: <a/>}} />;
    } else if (error.startsWith('invalid_grant: 70008')) {
      return <Trans t={t} i18nKey="errorMessage.expiredCode" components={{a: <a/>}} />;
    } else if (error.startsWith('invalid_grant: 9002313')) {
      return <Trans t={t} i18nKey="errorMessage.invalidCode" components={{a: <a/>}} />;
    } else {
      return <Trans t={t} i18nKey="errorMessage.unknown" values={{ logoutLink, error: JSON.stringify(error) }} components={{ a: <a/> }} />
    }
  }

  if (error) {
    return (
      <div className="page-login">
        <BtGrid>
          <BtRow>
            <BtColumn className="bt-w50 first-column bg-white">
              <BtCenter>
                <div className="app-login bt-w60">
                  <Logo size="194px" type="logoWithTitle" />
                  <h2>{t('pageTitle', 'Inloggningen misslyckades')}</h2>
                  {renderSsoError(error)}
                </div>
              </BtCenter>
            </BtColumn>
            <BtColumn className="second-column">
              <BtBackground className="bg-login bt-background-position-left" src={CraneImage} />
            </BtColumn>
          </BtRow>
        </BtGrid>
      </div>
    );
  } else {
    appState.setState({loader: true});
  }
}
